import { Box, Tabs, Tab, Typography, Switch } from "@mui/material";
import { SyntheticEvent } from "react";
import { ClientCleaningModel } from "./types";

export interface ClientTabsProps {
  data: ClientCleaningModel[] | undefined;
  selectedClient: ClientCleaningModel | undefined;
  onTabChange: (event: SyntheticEvent, newValue: string | number) => void;
  view: "pie" | "bar";
  onSwitchChange: () => void;
}

const ClientTabs = ({
  data,
  selectedClient,
  onTabChange,
  view,
  onSwitchChange,
}: ClientTabsProps) => {
  return (
    selectedClient?.clientName && (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: "4rem",
        }}
      >
        <Tabs
          value={selectedClient?.clientName}
          onChange={onTabChange}
          aria-label="client tabs"
          variant="scrollable"
          sx={{ width: "70%" }}
        >
          {data?.map((client) => (
            <Tab
              key={client.clientName}
              label={client.clientName}
              value={client.clientName}
            />
          ))}
        </Tabs>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Switch
            checked={view === "bar"}
            onChange={onSwitchChange}
            slotProps={{ input: { "aria-label": "switch view" } }}
          />
          <Typography component="span" variant="body1" sx={{ mt: "7px" }}>
            Switch view
          </Typography>
        </Box>
      </Box>
    )
  );
};

export default ClientTabs;
